export default __webpack_public_path__ + "static/media/EM0740.34I-23430_-15266_0.62514da3.jpg";